import { call, put, takeLatest } from 'redux-saga/effects';

import * as membershipActions from './membershipActions.js';
import { updateMembershipApiCall } from './membershipAPI.js';

function* updateMembershipSaga({ payload }) {
  try {
    const { data } = yield call(updateMembershipApiCall, payload);
    yield put(membershipActions.membershipUpdateStore(data));
  } catch (error) {
    yield put(membershipActions.membershipUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* membershipWatcher() {
  yield takeLatest(membershipActions.membershipUpdateRequest.type, updateMembershipSaga);
}
